import { QRFC } from "./QRFC";

export class QUpdateGuideStateRFC extends QRFC {
  constructor() {
    super();
  }

  Init(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
    this.SetAsync(true);
  }

  GetCallName() {
    return "guides";
  }

  SetParams(orgName, user, guideId, version, state) {
    this.AddParameter("org", orgName);
    this.AddParameter("user", user);
    this.AddParameter("guideId", guideId);
    this.AddParameter("version", version);
    this.AddParameter("state", state);
  }

  DoTransactionComplete(response, callBackObj) {
    const r = JSON.parse(response);
    callBackObj?.HandleGuideStateUpdated?.(r);
  }
}
